import normalizeLanguageCode from '../normalizeLanguageCode/normalizeLanguageCode';

/**
 * Turns comma delimited codes like en_us to en-US. Also en-us to en-US
 * @param str
 * @returns {string|*}
 */
export default (str) => {
  const arr = str.split(',');

  const codes = [];
  for (let i = 0; i < arr.length; i += 1) {
    codes.push(normalizeLanguageCode(arr[i]));
  }

  return codes.join(',');
};
